module.exports = __webpack_public_path__ + "img/currency-ruble-circle.674d140e.svg";